__turbopack_context__.v({
  "bar": "sBBOFa_bar",
  "fill": "sBBOFa_fill",
});
